import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { ServerErrorIllustration } from 'src/assets/illustrations';

// ----------------------------------------------------------------------

function formatErrorMessage(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error?.message) return error.message;
  return '';
}

/**
 * Recoverable error region with retry — use when SWR/API returns an error object.
 */
export function PageError({
  title = 'Something went wrong',
  description = 'We could not load this content. Check your connection and try again.',
  error,
  onRetry,
  retryLabel = 'Try again',
  illustration: Illustration = ServerErrorIllustration,
  sx,
}) {
  const detail = formatErrorMessage(error);

  return (
    <Stack
      alignItems="center"
      textAlign="center"
      spacing={2}
      sx={{ py: { xs: 3, md: 5 }, width: 1, ...sx }}
    >
      {Illustration ? (
        <Box sx={{ width: 1, maxWidth: 400 }}>
          <Illustration sx={{ width: 1, height: 'auto', maxHeight: 180 }} />
        </Box>
      ) : null}

      <Box>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: detail ? 2 : 0 }}>
          {description}
        </Typography>
        {detail ? (
          <Alert severity="error" variant="outlined" sx={{ textAlign: 'left', mt: 1 }}>
            {detail}
          </Alert>
        ) : null}
      </Box>

      {onRetry ? (
        <Button variant="contained" color="primary" onClick={onRetry}>
          {retryLabel}
        </Button>
      ) : null}
    </Stack>
  );
}
